import React from 'react';
import classes from './DirectionContents.module.css';

import Grid from '@mui/material/Unstable_Grid2';
import { Box, Typography } from '@mui/material';

import LocationOnIcon from '@mui/icons-material/LocationOn';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import CallIcon from '@mui/icons-material/Call';
import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop';
import MailOutlineIcon from '@mui/icons-material/MailOutline';


const components = {
    address: LocationOnIcon,
    businessHour: AccessTimeIcon,
    tel: CallIcon,
    fax: LocalPrintshopIcon,
    email: MailOutlineIcon
}
const ContentArea = props => {
    const Icon = components[props.icon];
    return (
        <Box display='flex' alignItems='center' className={classes['box-area']}>
            <Icon color="primary" className={classes.icon}/>
            <Typography variant="description">{props.description}</Typography>
        </Box>
    )
}

const DirectionContents = props => {
    return (
        <Box className={classes['direction-wrap']}>
            <Grid container spacing={2}>
                <Grid xs={12} md={6} >
                    <img src={props.map} alt="map" className={classes['map-image']}/>
                </Grid>

                <Grid xs={12} md={6} >
                    <Box sx={{padding: '10px'}}>
                        <Box>
                            <Typography variant="subTitle">{props.companyLocation}</Typography>
                        </Box>
                        <ContentArea icon='address' description={props.companyAddress} />
                        { props.businessHour && <ContentArea icon='businessHour' description={props.businessHour} /> }
                        { props.tel && <ContentArea icon='tel' description={props.tel} /> }
                        { props.fax && <ContentArea icon='fax' description={props.fax} /> }
                        { props.email && <ContentArea icon='email' description={props.email} /> }
                    </Box>
                </Grid>
            </Grid>
        </Box>
    )
}

export default DirectionContents;